import {
  BarElement,
  CategoryScale,
  Chart as ChartJS,
  Legend,
  LinearScale,
  Title,
  Tooltip,
} from "chart.js";
import { Bar } from "react-chartjs-2";
import {
  getPastSixMonths,
  getPastSixMonthsWithData,
  months,
} from "../../../utility/graphDataModifier";

export function BarChart({ graphData }) {
  ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
  );

  const options = {
    responsive: true,
    maintainAspectRatio: true,
    plugins: {
      legend: {
        display: false,
      }, // Hide legend
      title: {
        display: false,
      },
    },
    scales: {
      xAxes: [
        {
          categorySpacing: 9,
          barPercentage: 0,
        },
      ],
    },
  };

  const labels = getPastSixMonths();

  const data = {
    categoryPercentage: 1,
    labels,
    categorySpacing: 1,
    datasets: [
      {
        label: "Credited",
        data: getPastSixMonthsWithData(graphData, "totalCredits"),
        backgroundColor: "#C4C4C4",
        barThickness: 6,
      },
      {
        label: "Debited",
        data: getPastSixMonthsWithData(graphData, "totalDebits"),
        backgroundColor: "#6CA5FF",
        barThickness: 6,
      },
    ],

    Legend: {},
  };

  return <Bar options={options} data={data} />;
}
